// Copyright 2018 Sisense Inc. All rights reserved.
import * as styleUtils from './designSettings/styleUtils';
import themeServiceInstance from './designSettings/themeServiceInstance';

import './injectSvgIcons';
import './sass/base-all.scss';

const { SLF: SLF_CONSTANT } = require('./designSettings/constants');

export default {
    utils: styleUtils,
    themeService: themeServiceInstance,
    SLF: SLF_CONSTANT,
    injectStyles: themeServiceInstance.injectStyleRules,
    injectStylesWithWrapper: themeServiceInstance.injectStylesWithWrapper,
};
export const injectStyles = themeServiceInstance.injectStyleRules;
export const injectStylesWithWrapper = themeServiceInstance.injectStylesWithWrapper;
export const SLF = SLF_CONSTANT;
export const themeService = themeServiceInstance;
export const utils = styleUtils;
export const CONSTANTS = require('./designSettings/constants');
